module.exports = __webpack_public_path__ + "static/img/shareContentBg.9a8f439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/shareContentBg.png
// module id = OPdY
// module chunks = 0